'use strict';

import type { IndPhone } from '../../Entities/Ind/IndPhone';
import { EntityCollection } from '../EntityCollection';

export class IndPhoneCollection extends EntityCollection<IndPhone> {}
